import { Button, Dialog } from "@mui/material";
import { ParentCloseBtn, FadeTransition } from "common/elements";
import { useScale, btnDelay, usePlaySound, formatDateTime } from "common/utils";
import i18n from "features/parent/i18n";
import { ParentPieceComment } from "features/parent/types";

export const PieceCommentDetailModal = ({
  comment,
  onClose,
  onOpenPiece,
}: {
  comment: ParentPieceComment;
  onClose: () => void;
  /** 書いた先のピースの詳細をひらく */
  onOpenPiece: () => void;
}) => {
  const play = usePlaySound();
  const { scale } = useScale();

  return (
    <Dialog
      fullScreen
      open={true}
      maxWidth={false}
      sx={{ zIndex: 99999 }}
      TransitionComponent={FadeTransition}
      PaperProps={{ style: { backgroundColor: "transparent" } }}
    >
      <div className="flex-col-center w-full h-full bg-textcolor-black/50">
        <div style={{ transform: `scale(${scale})` }}>
          <div className="flex-col-el justify-start w-[760px] max-h-[760px] relative overflow-hidden border-solid border-gray2-30 border-[16px] rounded-[16px] bg-gray2-30">
            {/* スクロールバーと重ならないよう、少し内側に固定する */}
            <div className="flex-col-el absolute top-0 right-4 w-14 h-14 z-[110]">
              <ParentCloseBtn close={onClose} />
            </div>
            <div className="flex-col-el justify-start w-full flex-1 min-h-0 relative p-6 rounded-[8px] bg-white overflow-y-auto visible-scrollbar">
              <div className="flex-row-el items-center gap-2 mb-4 pb-3 border-b border-outline">
                <span className="material-symbols-outlined !text-[45px] text-red-100">
                  chat_bubble
                </span>
                <h2 className="text-[27px] text-textcolor-black">
                  {i18n.t("MSG_PARENT_PAGE_PLAYER_PIECE_COMMENTS")}
                </h2>
              </div>

              <div className="flex-col-el gap-3">
                <div className="flex-row-el items-center gap-2 whitespace-nowrap">
                  <span className="material-symbols-outlined text-[24px] text-red-100">
                    extension
                  </span>
                  <span className="text-[24px] text-textcolor-black">
                    {comment.piece_name ?? ""}
                  </span>
                  {comment.status !== "VISIBLE" && (
                    <span className="text-[19px] text-white px-3 py-1 rounded-full bg-gray2-100">
                      {i18n.t("MSG_PARENT_PAGE_PLAYER_PIECE_COMMENT_HIDDEN")}
                    </span>
                  )}
                </div>

                <p className="text-[21px] text-textcolor-black whitespace-pre-wrap break-all p-4 rounded-[12px] bg-gray2-20">
                  {comment.content}
                </p>

                <div className="flex-row-el items-center justify-between gap-4 text-[19px] text-gray2-100 pt-2 border-t border-outline">
                  {formatDateTime(comment.created_at)}
                  <Button
                    variant="outlined"
                    onClick={() => {
                      play();
                      btnDelay(onOpenPiece);
                    }}
                  >
                    {i18n.t("MSG_PARENT_PAGE_PLAYER_PIECE_OPEN")}
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Dialog>
  );
};
